import {Sprite} from 'pixi.js';
import {KeypadView, KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad';
import {SpinButtonViewMobileLandscape} from '@gongxigames/framework/slot/modules/spinbutton';

export class SpinButtonViewMobilePortrait extends SpinButtonViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('SpinButtonViewMobilePortrait');

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobilePortrait.NAME];
    }
}
